import { useEffect } from 'react';

import { generatePath, useNavigate } from 'react-router-dom';

import { useAuthentication } from '@zenbusiness/application-commons-authentication';
import PageLoading from '@zenbusiness/zui/PageLoading';

import { DEFAULT_SEGMENT } from '#client/build-env';
import * as ROUTES from '#client/constants/routes';
import { useUnifiedBusinessEntityContext } from '#client/contexts/UnifiedBusinessEntityProvider';
import useUserMode from '#client/hooks/useUserMode';

export default function Landing() {
  const { authenticated, login } = useAuthentication();
  const { loading: entityLoading, businessEntityUuid } = useUnifiedBusinessEntityContext();
  const userMode = useUserMode();
  const navigate = useNavigate();

  useEffect(() => {
    // Not authenticated - redirect to login
    if (!authenticated) {
      login(`${DEFAULT_SEGMENT}/chat`);
      return;
    }

    // Wait for business entity context and user mode to finish loading
    if (entityLoading || userMode.loading) {
      return;
    }

    // Route based on user mode
    if (userMode.isBusiness && businessEntityUuid) {
      // Business mode: redirect to legacy auto-create route
      navigate(generatePath(ROUTES.threadCreator, { businessEntityUuid }));
    } else {
      // All other modes (starter, anonymous, standalone) redirect to universal chat entry
      navigate(ROUTES.chatEntry);
    }
  }, [authenticated, entityLoading, userMode, businessEntityUuid, login, navigate]);

  return <PageLoading />;
}
